export default __webpack_public_path__ + "static/media/bread.a4e84b91.png";